import { FC } from 'react';
import { Wrapper } from './SwitchGroup.styled';

const SwitchGroup: FC = ({ children }) => <Wrapper>{children}</Wrapper>;

export { SwitchGroup };
